"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPOTButton = void 0;
var React = require("react");
require("./spot-button.scss");
var Spinner_1 = require("./basic/spinner/Spinner");
/**
 * Primary UI component for user interaction
 */
var SPOTButton = function (_a) {
    var _b = _a.type, type = _b === void 0 ? "secondary" : _b, backgroundColor = _a.backgroundColor, label = _a.label, props = __rest(_a, ["type", "backgroundColor", "label"]);
    var iconClassName = props.iconClassName ? props.iconClassName : "";
    return (React.createElement("button", __assign({}, props, { id: props.id, "data-test": props.dataTest, type: "button", className: ["spot-button", "spot-button--" + type].join(" "), style: { backgroundColor: backgroundColor }, disabled: props.disabled }),
        props.iconClassName && React.createElement("i", { className: iconClassName }),
        props.isLoading && (React.createElement("div", { className: "loading" },
            React.createElement(Spinner_1.Spinner, { isLoading: props.isLoading, color: "white", size: 18 }))),
        label));
};
exports.SPOTButton = SPOTButton;
//# sourceMappingURL=SPOTButton.js.map